import { render, staticRenderFns } from "./LogisticDetail.vue?vue&type=template&id=7c7130de&scoped=true"
import script from "./LogisticDetail.vue?vue&type=script&lang=js"
export * from "./LogisticDetail.vue?vue&type=script&lang=js"
import style0 from "./LogisticDetail.vue?vue&type=style&index=0&id=7c7130de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7130de",
  null
  
)

export default component.exports